import Navbar from "./Navbar"

export default Navbar
